import React, { useMemo } from "react";

import { Transaction } from "@codemirror/state";
import CodeMirror from "@uiw/react-codemirror";

function ManuscriptTextEditorHost({
    editorRef,
    editorContent,
    editorSessionKey,
    extensions,
    basicSetup,
    isRealtime = false,
    onEditorChange,
    onUpdate,
    onCreateEditor,
}) {
    const initialRealtimeValue = useMemo(() => editorContent, [editorSessionKey]);

    return (
        <div style={{ height: "100%" }}>
            <CodeMirror
                key={editorSessionKey}
                ref={editorRef}
                className="manuscript-codemirror"
                style={{ height: "100%" }}
                value={isRealtime ? initialRealtimeValue : editorContent}
                height="100%"
                extensions={extensions}
                basicSetup={basicSetup}
                onCreateEditor={(view) => onCreateEditor?.({ view, sessionKey: editorSessionKey })}
                onUpdate={onUpdate}
                onChange={(value, viewUpdate) => {
                    if (viewUpdate.transactions.some((transaction) => transaction.annotation(Transaction.remote))) {
                        return;
                    }
                    onEditorChange(value, viewUpdate.state.selection.main.head);
                }}
            />
        </div>
    );
}

export default ManuscriptTextEditorHost;
